import { STEP_WALL_DEFINITION } from "./stepWallLogic";
import { PRICE_WALL_DEFINITION } from "./priceWallLogic";
import { FRESHNESS_WALL_DEFINITION } from "./freshnessWallLogic";
import { MP_WALL_DEFINITION } from "./mpWallLogic";
import { OUTER_WALL_DEFINITION } from "./outerWallLogic";
import { SPLIT_WALL_DEFINITION } from "./splitWallLogic";
import { HG_WALL_DEFINITION } from "./hgWallLogic";
import { STOCK_WALL_DEFINITION } from "./stockWallLogic";
import { AMPLIFICATION_WALL_DEFINITION } from "./amplificationWallLogic";

export type WallId =
  | "step-wall"
  | "price-wall"
  | "freshness-wall"
  | "mp-wall"
  | "outer-wall"
  | "split-wall"
  | "hg-wall"
  | "stock-wall"
  | "amplification-wall";

export type WallFirstClearReward =
  | {
      readonly kind: "hov-core";
      readonly amount: number;
    }
  | {
      readonly kind: "ohov-mp-control-unlock";
    }
  | {
      readonly kind: "nhov-first-branch-selection-unlock";
    }
  | {
      readonly kind: "amplifier-la-da-availability-unlock";
    };

export interface WallDefinition {
  readonly id: WallId;
  readonly firstClearReward: WallFirstClearReward;
}

export const WALL_DEFINITIONS: readonly WallDefinition[] = [
  STEP_WALL_DEFINITION,
  PRICE_WALL_DEFINITION,
  FRESHNESS_WALL_DEFINITION,
  MP_WALL_DEFINITION,
  OUTER_WALL_DEFINITION,
  SPLIT_WALL_DEFINITION,
  HG_WALL_DEFINITION,
  STOCK_WALL_DEFINITION,
  AMPLIFICATION_WALL_DEFINITION,
];

export function getWallDefinition(wallId: WallId): WallDefinition {
  const definition = WALL_DEFINITIONS.find((entry) => entry.id === wallId);
  if (definition === undefined) {
    throw new Error(`Unknown wall id: ${wallId}`);
  }
  return definition;
}

export function getWallFirstClearReward(wallId: WallId): WallFirstClearReward {
  return getWallDefinition(wallId).firstClearReward;
}

export function getFirstClearHovCoreReward(wallId: WallId): number | null {
  const reward = getWallFirstClearReward(wallId);
  return reward.kind === "hov-core" ? reward.amount : null;
}

const WALL_IDS = new Set<WallId>(WALL_DEFINITIONS.map((wall) => wall.id));

export function isWallId(value: string): value is WallId {
  return WALL_IDS.has(value as WallId);
}
